import av1s from '../../images/avatars/av-1-s.png';
import av2s from '../../images/avatars/av-2-s.png';
import av3s from '../../images/avatars/av-3-s.png';
import av4s from '../../images/avatars/av-4-s.png';
import av5s from '../../images/avatars/av-5-s.png';
import av6s from '../../images/avatars/av-6-s.png';
import av7s from '../../images/avatars/av-7-s.png';
import av8s from '../../images/avatars/av-8-s.png';
import av9s from '../../images/avatars/av-9-s.png';
import av10s from '../../images/avatars/av-10-s.png';
import av11s from '../../images/avatars/av-11-s.png';
import av12s from '../../images/avatars/av-12-s.png';
import av13s from '../../images/avatars/av-13-s.png';
import av14s from '../../images/avatars/av-14-s.png';
import av15s from '../../images/avatars/av-15-s.png';
import av16s from '../../images/avatars/av-16-s.png';
import av17s from '../../images/avatars/av-17-s.png';
import av18s from '../../images/avatars/av-18-s.png';
import av19s from '../../images/avatars/av-19-s.png';
import av20s from '../../images/avatars/av-20-s.png';
import av1lg from '../../images/avatars/av-1-lg.png';
import av2lg from '../../images/avatars/av-2-lg.png';
import av3lg from '../../images/avatars/av-3-lg.png';
import av4lg from '../../images/avatars/av-4-lg.png';
import av5lg from '../../images/avatars/av-5-lg.png';
import av6lg from '../../images/avatars/av-6-lg.png';
import av7lg from '../../images/avatars/av-7-lg.png';
import av8lg from '../../images/avatars/av-8-lg.png';
import av9lg from '../../images/avatars/av-9-lg.png';
import av10lg from '../../images/avatars/av-10-lg.png';
import av11lg from '../../images/avatars/av-11-lg.png';
import av12lg from '../../images/avatars/av-12-lg.png';
import av13lg from '../../images/avatars/av-13-lg.png';
import av14lg from '../../images/avatars/av-14-lg.png';
import av15lg from '../../images/avatars/av-15-lg.png';
import av16lg from '../../images/avatars/av-16-lg.png';
import av17lg from '../../images/avatars/av-17-lg.png';
import av18lg from '../../images/avatars/av-18-lg.png';
import av19lg from '../../images/avatars/av-19-lg.png';
import av20lg from '../../images/avatars/av-20-lg.png';


const avatars = [
    { s: av1s, lg: av1lg },
    { s: av2s, lg: av2lg },
    { s: av3s, lg: av3lg },
    { s: av4s, lg: av4lg },
    { s: av5s, lg: av5lg }, 
    { s: av6s, lg: av6lg },
    { s: av7s, lg: av7lg },
    { s: av8s, lg: av8lg },
    { s: av9s, lg: av9lg },
    { s: av10s, lg: av10lg },
    { s: av11s, lg: av11lg },
    { s: av12s, lg: av12lg },
    { s: av13s, lg: av13lg },
    { s: av14s, lg: av14lg },
    { s: av15s, lg: av15lg },
    { s: av16s, lg: av16lg },
    { s: av17s, lg: av17lg },
    { s: av18s, lg: av18lg },
    { s: av19s, lg: av19lg },
    { s: av20s, lg: av20lg }
];

export default avatars;